// extracted by mini-css-extract-plugin
export default {"container":"Car_container__LRXEV","customTitle":"Car_customTitle__pT1sS","reservationContent":"Car_reservationContent__gpZjC"};